import { bindingsObj, loadings } from './stateBindings'

export const getInitialState = () => ({
  isConnectedBinding: null,
  isConnected: null,
  userBinding: null,
  user: {},
  claimsBinding: null,
  claimsLoading: true,
  claims: {},
  ...bindingsObj,
  ...loadings,
  selectedAccountId: '',
  userLookups: {},
  drawer: null,
  snackbar: { color: '', text: '', timeout: 6000 },
  showSnackbar: false,
  knownUsers: {},
  knownUsersLoading: false,
  knownUsersBinding: null,
  knownUsersIncludes: {},
  titleBarContents: {},
  sharesLoading: true,
  companyLoading: true,
  mfaEnabled: false
})
